import { RegulationFilterModel } from '../regulation';

export class UserRegulatorFilter {
  id: number;
  title: string;
  userId: number;
  filterJson: string;
  filters: RegulationFilterModel;

  constructor() {
    this.id = 0;
    this.title = '';
    this.userId = 0;
    this.filterJson = '';
    this.filters = new RegulationFilterModel();
  }
}
